import { Button, ButtonGroup, useMediaQuery, useTheme } from '@mui/material';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface ButtonsFilterProps {
    selected : string, 
    setSelected : (value: string ) => void;
    excludedCountries?: string[],
}
const ButtonsFilter = (props : ButtonsFilterProps) => {

  const {selected, setSelected, excludedCountries} = props;

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const {t} = useTranslation();

  const handleSelect = (value: string) => {
    setSelected(value);
  };

  // Definindo estilos diretamente no componente
  const buttonStyle = useMemo(() => {
    return {
    border: '2px solid black',
    borderRadius: 0,
    width: isMobile ? '75px' :'90px',
    height: isMobile ? '40px' : '50px',
    fontSize: isMobile ? 11.5 : 20,
    fontWeight: 'bold',
    fontFamily: 'PFDinTextCompPro-Medium, Arial, sans-serif',
    backgroundColor: 'transparent',
    color: 'black',
    margin: isMobile ? '3px' : undefined,
    marginRight: isMobile ? undefined : '15px',
  };
},[isMobile])

  const selectedStyle = {
    backgroundColor: 'black',
    fontFamily: 'PFDinTextCompPro-Medium, Arial, sans-serif',
    color: 'white',
  };

  return (
    <ButtonGroup variant="outlined" >
      <Button
        style={selected === t('LATAM') ? { ...buttonStyle, ...selectedStyle } : buttonStyle}
        onClick={() => handleSelect(t('LATAM'))}
      >
        {t('LATAM')}
      </Button>
      {excludedCountries && excludedCountries.includes('BRASIL') ? null : <Button
        style={selected === t('Countries.BRASIL') ? { ...buttonStyle, ...selectedStyle } : buttonStyle}
        onClick={() => handleSelect(t('Countries.BRASIL'))}
      >
        {t('Countries.BRASIL')}
      </Button>}
      {excludedCountries && excludedCountries.includes('PERU') ? null : <Button
        style={selected === t('Countries.PERU') ? { ...buttonStyle, ...selectedStyle } : buttonStyle}
        onClick={() => handleSelect(t('Countries.PERU'))}
      >
        {t('Countries.PERU')}
      </Button>}
      {excludedCountries && excludedCountries.includes('ARGENTINA') ? null : <Button
        style={selected === t('Countries.ARGENTINA') ? { ...buttonStyle, ...selectedStyle } : buttonStyle}
        onClick={() => handleSelect(t('Countries.ARGENTINA'))}
      >
        {t('Countries.ARGENTINA')}
      </Button>}
      {excludedCountries && excludedCountries.includes('CHILE') ? null : <Button
        style={selected === t('Countries.CHILE') ? { ...buttonStyle, ...selectedStyle } : buttonStyle}
        onClick={() => handleSelect(t('Countries.CHILE'))}
      >
        {t('Countries.CHILE')}
      </Button>}
      {excludedCountries && excludedCountries.includes('URUGUAI') ? null : <Button
        style={selected === t('Countries.URUGUAI') ? { ...buttonStyle, ...selectedStyle } : buttonStyle}
        onClick={() => handleSelect(t('Countries.URUGUAI'))}
      >
        {t('Countries.URUGUAI')}
      </Button>}
    </ButtonGroup>
  );
};

export default ButtonsFilter;
